<template>
   <div class="ev-map-station">

    <!-- START Search Text Box -->
    <div class="search-station-keyword-box">
      <input type="text" class="form-control" placeholder="Search"
             v-model="selectedOptions.keyword" autocomplete="off" @keyup.enter="searchStation" />
      <button class="keyword-delete-btn" :style="selectedOptions.keyword ? 'display: block' : 'display: none'"
              @click="selectedOptions.keyword = null">
        <i class="mdi mdi-close"/>
      </button>
    </div>
    <!-- END Search Text Box -->

    <!-- START Search Station Conditions -->
    <b-collapse id="detailSearchStationCollapse" v-model="detailSearchStationCheck">
<!--      <div class="row">-->
<!--        <div class="col-md-6 mb-2">-->
<!--          <multiselect v-model="selectedOptions.address1" :options="address1Options"-->
<!--                       label="text" placeholder="" select-label=""-->
<!--                       :allow-empty="false" deselect-label=""-->
<!--                       @input="getAddress2Options">-->
<!--            <span slot="noResult">No Result</span>-->
<!--          </multiselect>-->
<!--        </div>-->
<!--        <div class="col-md-6 mb-2">-->
<!--          <multiselect v-model="selectedOptions.address2" :options="address2Options"-->
<!--                       label="text" placeholder="" select-label=""-->
<!--                       :allow-empty="false" deselect-label="">-->
<!--            <span slot="noResult">No Result</span>-->
<!--          </multiselect>-->
<!--        </div>-->
<!--      </div>-->

      <div class="row">
        <div class="col-lg-3 mb-2 " v-for="item in chargerTypeOptions">
          <b-button variant="tansparent" class="w-100 btn-rounded" size="sm"
                    :class="isChargerTypeSelected(`${item.value}`) ? 'charger-type-select' : 'charger-type-unselect'"
                    @click="chargerTypeToggle(item.value)">
            <span class="font-size-12">{{ item.label }}</span>
          </b-button>
        </div>
      </div>
      <div class="row">
        <!--        <div class="col-md-6 mb-2">-->
        <!--          <multiselect v-model="selectedOptions.agency" :options="agencyOptions"-->
        <!--                       label="text" placeholder="" select-label=""-->
        <!--                       :allow-empty="false" deselect-label="">-->
        <!--            <span slot="noResult">No Result</span>-->
        <!--          </multiselect>-->
        <!--        </div>-->
        <div class="col-6 mb-2 d-flex align-items-center">
          <div class="form-check form-check-main-green form-switch mt-1">
            <input type="checkbox" class="form-check-input" id="limit-station-checkbox"
                   v-model="selectedOptions.limitYn"/>
            <label class="form-check-label" for="limit-station-checkbox">{{ selectedOptions.isUnlimited ? '개방' : '비개방' }}</label>
          </div>
        </div>
        <div class="col-md-3 col-6 mb-2  d-flex align-items-center">
          <div class="form-check form-check-main-green form-switch mt-1">
            <input type="checkbox" class="form-check-input" id="parking-free-checkbox"
                   v-model="selectedOptions.parkingFree"/>
            <label class="form-check-label" for="parking-free-checkbox">{{ selectedOptions.isParkingFree ? '주차 무료' : '주차 유료' }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
    <!-- END Search Station Conditions -->

    <!-- START Search Station Button Area -->
    <div class="row mt-2">
      <div class="col-6">
<!--        <div class="form-check form-check-deep-green form-switch mt-1">
          <input type="checkbox" class="form-check-input" id="stationFlexSwitchCheckDefault"
                 v-model="detailSearchStationCheck"
                 :aria-expanded="detailSearchStationCheck ? 'true' : 'false'"
                 aria-controls="detailSearchStationCollapse" />
          <label class="form-check-label" for="stationFlexSwitchCheckDefault">상세 검색</label>
        </div>-->
      </div>
      <search-buttons layout-class="col-6" btn-size="sm" :reset-fn="reset" :search-fn="searchStation" />
    </div>
    <!-- END Search Station Button Area -->

    <!-- START Station Result List -->
    <div class="search-station-result" v-if="stationResult.stationList.length>0 || stationResult.kakaoList.length>0">
      <hr/>
      <b-tabs v-model="tabIndex" content-class="pt-3 text-muted" justified nav-class="nav-tabs-custom">

        <!-- START Tab1 -->
        <b-tab active class="border-0">
          <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-gas-pump"/> / {{ $_utils.comma(stationPage.totalCount) }} 건
          </span>
            <span class="d-none d-sm-inline-block">충전소 ({{ $_utils.comma(stationPage.totalCount) }}건)</span>
          </template>

          <ev-map-station-list sidebar-mode="station"
                               collapse-id="collapse-station-result"
                               :detail-option-check="detailSearchStationCheck"
                               :station-result-list="stationResult.stationList"
                               @showOnMap="showOnMap"
                               @showNavi="showNavi" />
          <div class="mt-3" style="text-align: right">
            <b-pagination class="pagination-no-border" align="center" size="sm" v-model="stationPage.currentPage"
                          first-number last-number prev-text="<" next-text=">"
                          :total-rows="stationPage.totalCount" :per-page="stationPage.perPage" @change="onPageChange"/>
          </div>
        </b-tab>
        <!-- END Tab1 -->

        <!-- START Tab2 -->
        <b-tab class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-city"/> / {{ kakaoPage.totalCount }} 건
            </span>
            <span class="d-none d-sm-inline-block">주변 장소 ({{ kakaoPage.totalCount }}건)</span>
          </template>

          <ev-map-around-list :around-result-list="stationResult.kakaoList"
                              @showOnMap="showOnMap" />
          <div class="mt-3" style="text-align: right">
            <b-pagination class="pagination-no-border" align="center" size="sm" v-model="kakaoPageInfo.currentPage"
                          first-number last-number prev-text="<" next-text=">"
                          :total-rows="kakaoPageInfo.totalCount" :per-page="kakaoPageInfo.perPage"
                          @change="onPageChange2"/>
          </div>
        </b-tab>
        <!-- END Tab2 -->
      </b-tabs>

    </div>
  </div>
</template>

<script>
import SearchButtons from "@/views/components/searchButtons.vue"
import Multiselect from "vue-multiselect";
import EvMapAroundList from "@/views/pages/maps/evMapAroundList.vue";
import EvMapStationList from "@/views/pages/maps/evMapStationList.vue";

export default {
  name: "evMapStation",
  components: { EvMapStationList, EvMapAroundList, Multiselect, SearchButtons },
  props: {
    searchKeyword: String,
    result: Object,
    stationPage: Object,
    kakaoPage: Object,
  },
  data() {
    return {
      detailSearchStationCheck: false,
      address1Options: [],
      address2Options: [],
      agencyOptions: [],
      chargerTypeOptions: [
        { label: 'DC콤보', value: '04' },
        { label: '차데모', value: '01' },
        { label: 'AC3상', value: '07' },
        { label: '완속', value: '02' }
      ],
      selectedOptions: {
        keyword: null,
        // address1: { value: 'all', text: '시/도 (전체)' },
        // address2: { value: 'all', text: '시/군/구 (전체)' },
        // agency: { value: 'all', text: '운영 기관 (전체)' },
        isUnlimited: true,
        isParkingFree: true,
        // kind: { value: 'all', text: '시설 유형 (전체)' },
        chargerType: ['01', '02', '04', '07']
      },
      tabIndex: 0,
      stationResult: this.result,
      chargerResult: null,
      kakaoPageInfo: {
        currentPage: this.kakaoPage.current,
        totalCount: this.kakaoPage.totalCount,
        perPage: this.kakaoPage.perPage
      },
      initMapOptions: {
        lat: 37.498204,   // 위도 (I-ON)
        lng: 127.032685,   // 경도 (I-ON)
        level: 4,
      },
    }
  },
  watch: {
    searchKeyword(val) {
      const vm = this;
      vm.selectedOptions.keyword = val;
    }
  },
  created() {
    const vm = this;

    // vm.getAddress1Options();
    // vm.getAgencyOptions();
    // vm.address2Options = [
    //   { value: 'all', text: '시/군/구 (전체)' },
    //   { text: '--시/도 를 선택하세요--' , $isDisabled: true }
    // ];
  },
  methods: {
    //--------상세검색 (미사용)------
    getAddress1Options() {
      const vm = this;

      const sidoList = this.$_app.mapCode
        .filter(ele => ele.parent_code_id === 'zcode')
        .sort((a,b) => a.order_num - b.order_num);

      vm.address1Options = [
        { value: 'all', text: '시/도 (전체)' },
        ...sidoList.map(ele => ({ value: ele.code_id, text: ele.code_name }))
      ];
    },
    getAgencyOptions() {
      const vm = this;

      const operatorList = this.$_app.mapCode
        .filter(ele => ele.parent_code_id === 'operator')
        .sort((a,b) => a.order_num - b.order_num);

      vm.agencyOptions = [
        { value: 'all', text: '운영 기관 (전체)' },
        ...operatorList.map(ele => ({ value: ele.code_id, text: ele.code_name }))
      ];
    },
    getAddress2Options() {
      const vm = this;

      const selectedAddress1 = vm.selectedOptions.address1.value;
      const sigunguList = this.$_app.mapCode
        .filter(ele => ele.parent_code_id === selectedAddress1)
        .sort((a,b) => a.order_num - b.order_num);

      vm.selectedOptions.address2 = { value: 'all', text: '시/군/구 (전체)' };

      if (selectedAddress1 !== 'all') {
        vm.address2Options = [
          { value: 'all', text: '시/군/구 (전체)' },
          ...sigunguList.map(ele => ({ value: ele.code_id, text: ele.code_name }))
        ];
      } else {
        vm.address2Options = [
          { value: 'all', text: '시/군/구 (전체)' },
          { text: '--시/도 를 선택하세요--' , $isDisabled: true }
        ];
      }
    },
    //--------상세검색 (미사용)------

    chargerTypeToggle(val) {
      const vm = this;
      const _index = vm.selectedOptions.chargerType.indexOf(val);

      if (_index > -1) {
        vm.selectedOptions.chargerType.splice(_index, 1);
      } else {
        vm.selectedOptions.chargerType.push(val);
      }

      if(vm.selectedOptions.chargerType.includes('02') ) {
        this.$emit('changeChargerSpeed', vm.selectedOptions.chargerType.length === 1 ? 'ac' : 'all');
      } else if (vm.selectedOptions.chargerType.length >= 1 ) {
        this.$emit('changeChargerSpeed', 'dc');
      }
    },
    searchStation() {
      const vm = this;

      this.$emit('searchStation', 'multi', vm.selectedOptions);
      this.$nextTick(() => {
        if (vm.stationResult.station.length > 0) {
          vm.detailSearchStationCheck = false;
        }
        vm.tabIndex = 0;
      });
    },
    isChargerTypeSelected(val) {
      const vm = this;
      return vm.selectedOptions.chargerType.includes(val);
    },
    showNavi(item) {
      this.$emit('showNavi', item);
    },
    showOnMap(type, subType, item, id) {
      this.$emit('showOnMap', type, subType, item);
    },
    onPageChange(val) {
      if (this.stationPage.totalCount > 100) {
        this.$emit('onPageChange', val);
      }
    },
    onPageChange2(val) {
      const vm = this;
      vm.kakaoPageInfo.currentPage = val;

      if (vm.kakaoPageInfo.totalCount > 15) {
        this.kakaoPage.gotoPage(vm.kakaoPageInfo.currentPage);
      }
    },
    // addFavorites() {
    //   this.$swal('COMING SOON', '', 'info');
    // },
    reset() {
      const vm = this;

      // vm.address2Options = [{ value: 'all', text: '시/군/구 (전체)' }];
      vm.selectedOptions = {
        keyword: null,
        // address1: { value: 'all', text: '시/도 (전체)' },
        // address2: { value: 'all', text: '시/군/구 (전체)' },
        // agency: { value: 'all', text: '운영 기관 (전체)' },
        isUnlimited: true,
        isParkingFree: true,
        // kind: { value: 'all', text: '시설 유형 (전체)' },
        chargerType: ['01', '02', '04', '07']
      },
      this.$emit('reset');
    }
  }
}
</script>